import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import { AffinityRule, CreateAffinityPayload } from "../../recommendation.types";

export const requestAddAffinityRule = async (
  payload: CreateAffinityPayload
): Promise<AffinityRule> => {
  return await instance.post(ApiRoutesRecommendation.Affinity, payload);
};
